import type { SearchValues } from "../types";

export const searchValues: SearchValues = {
  name: "",
  isActive: "",
};

export const excelHeaderCellsName: Record<string, string> = {
  "المعرف": "id",
  "الاسم": "name",
  "الرابط": "slug",
  "نشط": "isActive",
};
